import { SvgIcon } from '@mui/material'

// Types
import type { SvgIconProps } from '@mui/material'

const ScanIconAtom = (props: SvgIconProps) => (
	<SvgIcon {...props} viewBox="0 0 24 24">
		<path fill="none" stroke="currentColor" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" d="M2 9V6.5C2 4.01 4.01 2 6.5 2H9" />

		<path fill="none" stroke="currentColor" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" d="M15 2H17.5C19.99 2 22 4.01 22 6.5V9" />

		<path fill="none" stroke="currentColor" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" d="M22 16V17.5C22 19.99 19.99 22 17.5 22H16" />

		<path fill="none" stroke="currentColor" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" d="M9 22H6.5C4.01 22 2 19.99 2 17.5V15" />

		<path
			opacity={0.4}
			fill="none"
			stroke="currentColor"
			strokeWidth={1.5}
			strokeLinecap="round"
			strokeLinejoin="round"
			d="M10.5 7H8.5C7.67 7 7 7.67 7 8.5V10.5C7 11.33 7.67 12 8.5 12H10.5C11.33 12 12 11.33 12 10.5V8.5C12 7.67 11.33 7 10.5 7Z"
		/>

		<path opacity={0.4} fill="none" stroke="currentColor" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" d="M17 9.5V8.5C17 7.67 16.33 7 15.5 7H15" />

		<path opacity={0.4} fill="none" stroke="currentColor" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" d="M7 15V15.5C7 16.33 7.67 17 8.5 17H9" />

		<path opacity={0.4} fill="none" stroke="currentColor" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" d="M14.5 14.5V17H17V14.5H14.5Z" />
	</SvgIcon>
)

export default ScanIconAtom
